// extracted by mini-css-extract-plugin
export default {"header":"styles_header__SaYC3","logo":"styles_logo__zKWgU","companyLogo":"styles_companyLogo__WR+z5"};